import type { CSSProperties, ReactNode } from 'react'
import type { AvatarDecoration } from '@/types/api'
import { cx } from '@/lib/cx'
import { streamLabel } from '@/lib/streamView'
import { Avatar } from '../Avatar'
import styles from './StreamPreview.module.css'

/** Красный значок «В ЭФИРЕ», как LIVE у Discord. */
export function LiveBadge({ className }: { className?: string | undefined }) {
  return <span className={cx(styles.live, className)}>В ЭФИРЕ</span>
}

/**
 * Заглушка вместо кадра: аватар показывающего, «Экран <ник>» и название окна, если его прислали.
 * Живого превью нет сознательно: демонстрация идёт одним слоем без simulcast, и даже крошечная
 * картинка стоила бы подписки на полный поток.
 */
export function StreamPlaceholder({ name, title, avatar, decoration, color, size = 64, className, children }: {
  name: string
  title?: string | undefined
  avatar?: string | undefined
  /** Рамка аватара показывающего — как везде, где виден его аватар. */
  decoration?: AvatarDecoration | null | undefined
  color: string
  size?: number
  className?: string | undefined
  children?: ReactNode
}) {
  return (
    <div className={cx(styles.placeholder, className)} style={{ '--tint': color } as CSSProperties}>
      <Avatar initial={name.slice(0, 1).toUpperCase()} color={color} size={size} src={avatar} decoration={decoration} />
      <span className={styles.label}>{streamLabel(name)}</span>
      {title ? <span className={styles.window} data-tooltip={title}>{title}</span> : null}
      {children}
    </div>
  )
}
